import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import AddControl from 'components/add_control';
import MultiselectModal from 'components/multiselect_modal';

export function PropertyTypes({ propertyTypeOptions, propertyTypeIds, canEditPropertyTypes, onPropertyTypeIdsChange }) {
  const [showModal, setShowModal] = useState(false);

  const handleSave = (selectedPropertyTypeOptions) =>{
    onPropertyTypeIdsChange(selectedPropertyTypeOptions.map(option => parseInt(option.value)));
  };

  let initialValue = [];
  let control = !canEditPropertyTypes ? <div className="text-muted">All</div> : (
    <AddControl onClick={() => setShowModal(true)}>
      Add Property Types
    </AddControl>
  );

  if (propertyTypeIds && propertyTypeIds.length > 0) {
    initialValue = propertyTypeOptions.filter(option => propertyTypeIds.includes(option.value));

    let controlText;
    if (propertyTypeIds.length === 1) {
      controlText = propertyTypeOptions.find(option => option.value === propertyTypeIds[0]).label;
    } else {
      controlText = `${propertyTypeIds.length} Property Types`;
    }

    control = !canEditPropertyTypes ? controlText : (
      <a className="clickable" onClick={() => setShowModal(true)}>
        {controlText}
      </a>
    );
  }

  return (
    <React.Fragment>
      <td>
        {control}
      </td>

      <MultiselectModal
        allowEmptySelection
        defaultValue={initialValue}
        hideSearch
        options={propertyTypeOptions}
        optionsLabel="Property Types"
        show={showModal}
        title="Add Property Types"
        onClose={() => setShowModal(false)}
        onSave={handleSave}
      />
    </React.Fragment>
  );
}

PropertyTypes.propTypes = {
  canEditPropertyTypes: PropTypes.bool.isRequired,
  propertyTypeIds: PropTypes.arrayOf(PropTypes.number),
  propertyTypeOptions: PropTypes.arrayOf(PropTypes.object),
  onPropertyTypeIdsChange: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  canEditPropertyTypes: state.canEditPropertyTypes,
  propertyTypeOptions: state.propertyTypeOptions
});

export default connect(mapStateToProps)(PropertyTypes);
